import LoanService from "@/services/Bubble/finsey/LoanService";
import SchoolService from "@/services/Bubble/finsey/SchoolService";
import ScoreService from "@/services/Bubble/finsey/ScoreService";
import OtpService from "@/services/Bubble/finsey/OtpService";
import ApplicationService from "@/services/Bubble/finsey/ApplicationService";
import EkycService from "@/services/Bubble/finsey/EkycService";
import ViettelEkycService from "./Viettel/EkycService";
import BlogService from '@/services/Bubble/finsey/BlogService';
import AppwriteService from "./Appwrite/AppwriteService";
import ReferralService from "@/services/Bubble/finsey/ReferralService";
import HopeService from "@/services/Bubble/finsey/HopeService";
import ContractService from "@/services/Bubble/finsey/ContractService";
import CustomerService from "@/services/Bubble/finsey/CustomerService";
import PaymentService from "@/services/PayOS/PaymentService";
import CalculatorService from "@/services/Calculator/CalculatorService";
import UpgradService from "@/services/Calculator/UpgradService";
import CourseService from "@/services/Bubble/upgrad/course.service";
import UpgradApplicationService from "@/services/Bubble/upgrad/application.service"
import UpgradLoanManagementService from "@/services/Bubble/upgrad/loan-management.service"
import FinseyScoreService from "@/services/Score/Finsey"

export {
    CalculatorService,
    UpgradService,
    AppwriteService,
    PaymentService,
    ContractService,
    HopeService,
    ReferralService,
    ViettelEkycService,
    EkycService,
    ApplicationService,
    LoanService,
    SchoolService,
    ScoreService,
    OtpService,
    BlogService,
    CustomerService,
    CourseService,
    UpgradApplicationService,
    UpgradLoanManagementService,
    FinseyScoreService
};
